var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegetables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 6C9.85057 6 8.27047 8.01532 8.78325 10.1026L11.3318 20.4761C11.4073 20.7837 11.6831 21 11.9999 21C12.3167 21 12.5925 20.7837 12.6681 20.4761L15.2166 10.1026C15.7294 8.01531 14.1493 6 11.9999 6ZM6.84101 10.5797C6.0186 7.23218 8.55279 4 11.9999 4C15.4471 4 17.9813 7.23219 17.1589 10.5798L14.6104 20.9533C14.3151 22.1551 13.2374 23 11.9999 23C10.7624 23 9.68475 22.1551 9.38951 20.9533C9.38951 20.9533 9.38951 20.9533 9.38951 20.9533L6.84101 10.5797Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 1C12.5522 1 12.9999 1.44772 12.9999 2V4.75C12.9999 5.30228 12.5522 5.75 11.9999 5.75C11.4476 5.75 10.9999 5.30228 10.9999 4.75V2C10.9999 1.44772 11.4476 1 11.9999 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6935 2.02987C16.1166 2.38487 16.1718 3.01563 15.8168 3.4387L14.4532 5.06372C14.0982 5.48679 13.4674 5.54197 13.0443 5.18696C12.6213 4.83195 12.5661 4.2012 12.9211 3.77813L14.2847 2.1531C14.6397 1.73003 15.2705 1.67486 15.6935 2.02987Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35715 2.02985C8.78022 1.67485 9.41098 1.73004 9.76598 2.15311L11.1295 3.77814C11.4845 4.20122 11.4293 4.83197 11.0063 5.18697C10.5832 5.54197 9.95244 5.48679 9.59743 5.06371L8.23388 3.43869C7.87888 3.01561 7.93407 2.38485 8.35715 2.02985Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99993 9.5C6.99993 8.94772 7.44765 8.5 7.99993 8.5H10.9999C11.5522 8.5 11.9999 8.94772 11.9999 9.5C11.9999 10.0523 11.5522 10.5 10.9999 10.5H7.99993C7.44765 10.5 6.99993 10.0523 6.99993 9.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4999 13C11.4999 12.4477 11.9476 12 12.4999 12H15.4999C16.0522 12 16.4999 12.4477 16.4999 13C16.4999 13.5523 16.0522 14 15.4999 14H12.4999C11.9476 14 11.4999 13.5523 11.4999 13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49993 17C8.49993 16.4477 8.94765 16 9.49993 16H11.4999C12.0522 16 12.4999 16.4477 12.4999 17C12.4999 17.5523 12.0522 18 11.4999 18H9.49993C8.94765 18 8.49993 17.5523 8.49993 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetables);
export default __webpack_public_path__ + "static/media/vegetables.6db8f028c787318824ca0f65d2bee010.svg";
export { ForwardRef as ReactComponent };